import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import styled from "styled-components";
import FPJS from "./FPJS";
import Flagged from "./Flagged";

const Radar = ({ userId }) => {

    const [value, setValue] = useState(0);

    const tabsConfig = [
        { label: "FPJS", content: <FPJS userId={userId} /> },
        { label: "Flagged", content: <Flagged userId={userId} /> },
    ];

    return (
        <Wrapper>
            <div className="tabs-wrapper">
                <Tabs
                    value={value}
                    onChange={(_, newValue) => setValue(newValue)}
                    aria-label="radar tabs"
                    TabIndicatorProps={{ style: { backgroundColor: "#607afc" } }}
                >
                    {tabsConfig.map((tab, index) => (
                        <Tab key={index} label={tab.label} />
                    ))}
                </Tabs>
            </div>

            <Box sx={{ p: 3, textAlign: "center" }}>{tabsConfig[value].content}</Box>
        </Wrapper>
    );
};

export default Radar;

const Wrapper = styled.div`
  .tabs-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    min-height: 48px;
    align-items: flex-end;
    gap: 8px;
    margin-bottom: 20px;
    justify-content: center;
    border-bottom: 1px solid #e0e0e0;
    width: fit-content;
    margin: 0 auto;
  }

  .MuiButtonBase-root {
    text-transform: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
  }
  .MuiTab-root.Mui-selected {
    color: #1976d2;
    font-weight: 600;
  }
`;
